import { makeStyles, alpha } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles((theme) => ({
	pluginFeatureIconCircle: {
		width: 19,
		height: 19,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
		borderRadius: "50%"
	},
	tagCard: {
		borderRadius: 22,
		height: theme.spacing(3),
		width: "95%",
		fontSize: 15,
		marginBottom: theme.spacing(1),
		color: "white",
		display: "flex",
		alignItems: "center"
	},
	closeIcon: {
		float: "right",
		"& svg": {
			fontSize: "1rem"
		}
	},
	inputBase: {
		padding: 10,
		width: "100%",
		borderBottom: `1px solid ${colors.blue[200]}`,
		"& input": {
			borderRadius: 4,
			...ColorUtil.getBackgroundAndContrastColor(theme.palette.common.white),
			padding: 8,
			transition: theme.transitions.create(["border-color", "box-shadow"]),
			border: `1px solid ${colors.blue[200]}`,
			fontSize: 14,
			"&:focus": {
				boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
				borderColor: theme.palette.primary.main
			}
		}
	},
	close: {
		opacity: 0.6,
		width: 18,
		height: 18
	},
	text: {
		flexGrow: 1
	},
	iconSelected: {
		width: 17,
		height: 17,
		marginRight: 5,
		marginLeft: -2
	},
	color: {
		width: 14,
		height: 14,
		flexShrink: 0,
		borderRadius: 3,
		marginRight: 8,
		marginTop: 2
	},
	popperDisablePortal: {
		position: "relative"
	},
	option: {
		minHeight: "auto",
		alignItems: "flex-start",
		padding: 8,
		"&[aria-selected='true']": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		},
		"&[data-focus='true']": {
			...ColorUtil.getBackgroundAndContrastColor(theme.palette.action.hover)
		}
	},
	paper: {
		boxShadow: "none",
		margin: 0,
		color: colors.blue[900],
		fontSize: 13
	},
	popper: {
		border: "1px solid rgba(27,31,35,.15)",
		boxShadow: "0 3px 12px rgba(27,31,35,.15)",
		borderRadius: 3,
		width: 300,
		fontSize: 13,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[50])
	},
	loadingTagAction: {
		color: colors.gray[0]
	},
	pluginFeatureIcon: {
		width: 16,
		height: 16
	},
	scrollBar: {
		maxHeight: 167,
		overflowY: "auto",
		width: "100%",
		"&::-webkit-scrollbar": {
			width: "0.3em"
		},
		"&::-webkit-scrollbar-track": {
		},
		"&::-webkit-scrollbar-thumb": {
			border: "none",
			outline: 1,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		}
	},
	tagName: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "-webkit-box",
		"-webkit-line-clamp": 1,
		"-webkit-box-orient": "vertical"
	}
}))

export default useStyles
